import Repository from './Repository';

import { vue } from '../main';
import InstanceRepository from './InstanceRepository';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/history`;


export default {
  /**
   * Undoes the last action.
   * Possible error codes:
   * 1847510 = Empty History
   *
   * @returns {Promise<AxiosResponse<T> | never>}
   */
  rewind() {
    return Repository.post(`${base}/rewind`)
      .then(() => {
        vue.$snotify.info('Your last action has been undone.');
        InstanceRepository.refetchActive(false);
      });
  },
};
